'use client';

import { useEffect } from 'react';

const SUFFIX = ' — Galexia';

/**
 * Sets document.title to "{title} — Galexia" while the calling component is
 * mounted. Restores the previous title on unmount so navigations don't leak
 * the conversation title onto the next route.
 *
 * Pass undefined / empty string to skip — the original layout title stays.
 *
 * Used by chat-view and the lab so users with multiple chat tabs open can
 * tell them apart from the browser tab strip.
 */
export function useDocumentTitle(title: string | undefined | null) {
  useEffect(() => {
    if (!title || typeof document === 'undefined') return;
    const previous = document.title;
    const next = title.endsWith(SUFFIX) ? title : `${title}${SUFFIX}`;
    document.title = next;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
